import { z } from "zod";

export const SlackBotIdentitySchema = z.object({
  userId: z.string(),
  botId: z.string(),
  name: z.string().optional(),
  photoUrl: z.string().optional()
});
export type SlackBotIdentity = z.infer<typeof SlackBotIdentitySchema>;
